import { SCRAM_HASH_FUNCTION } from '@lucidlink/ts-crypto/scram';
import { calculateBase64Size } from '@lucidlink/ts-crypto/utils';
import { digestOutput, NONCE_BASE64_LENGTH, } from '#validation/common/constants';
export { SCRAM_HASH_FUNCTION, SCRAM_ITERATION_COUNT, } from '@lucidlink/ts-crypto/scram';
export const SALT_BASE64_MIN_LENGTH = 32;
export const SALT_BASE64_MAX_LENGTH = 64;
export const NONCE_BASE64_MIN_LENGTH = 32;
export const NONCE_BASE64_MAX_LENGTH = 64;
export const FULL_NONCE_BASE64_LENGTH = 2 * NONCE_BASE64_LENGTH;
export const FULL_NONCE_BASE64_MIN_LENGTH = 64;
export const FULL_NONCE_BASE64_MAX_LENGTH = 128;
export const STORED_KEY_BASE64_LENGTH = calculateBase64Size(digestOutput[SCRAM_HASH_FUNCTION] / 8);
export const CLIENT_PROOF_BASE64_LENGTH = calculateBase64Size(digestOutput[SCRAM_HASH_FUNCTION] / 8);
